<template>
  <Modal
    title="Изменение параметров нагрузки"
    :is-show="isShow"
    @close="close"
  >
    <form
      class="form"
      @submit.prevent="submit"
    >
      <div class="capacity">
        <div class="capacity-label">Нагрузка:</div>
        <div class="capacity-value">
          {{ form.rack_kit_weight }} кг на стеллаж
          <br>
          {{ form.tier_shelf_weight }} кг на полку
        </div>
      </div>

      <p>
        <b>Вы можете увеличить нагрузку, добавив дополнительные опции:</b>
      </p>

      <div class="controlList">
        <div class="controlList-item">
          <Checkbox
            v-model="form.rack_kit_strong"
            hint="Увеличивает базовую нагрузку на стеллаж"
          >
            Заменить стойки Standart на Strong
          </Checkbox>
        </div>
        <div class="controlList-item">
          <Checkbox
            v-model="form.tier_shelf_strong"
            hint="Увеличивает базовую нагрузку на полки"
          >
            Заменить полки Standart на Strong
          </Checkbox>
        </div>
        <div class="controlList-item">
          <Checkbox
            v-model="form.tier_shelf_ribs"
            hint="Увеличивают базовую нагрузку на полки на 10%"
          >
            Добавить ребра полок
          </Checkbox>
        </div>
      </div>

      <br>

      <div class="controlList">
        <div
          v-for="(option, i) in fastenersOptions"
          :key="i"
          class="controlList-item"
        >
          <Radio
            v-model="form.fasteners"
            :value="option.value"
            :hint="option.hint"
            :disabled="option.disabled"
          >
            {{ option.text }}
          </Radio>
        </div>
      </div>

      <div class="field">
        <button
          type="submit"
          class="btn"
        >
          <span>Применить</span>
        </button>
        <button
          type="button"
          class="btn"
          @click="close"
        >
          <span>Отмена</span>
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
  import logic from '../logic';
  import Modal from './Modal.vue';
  import Radio from './Radio.vue';
  import Checkbox from './Checkbox.vue';

  export default {
    components: {
      Modal,
      Radio,
      Checkbox,
    },
    props: {
      isShow: Boolean,
      separate: Boolean,
      value: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        form: {
          rack_kit_weight: 0,
          tier_shelf_weight: 0,
          rack_kit_strong: false,
          tier_shelf_strong: false,
          tier_shelf_ribs: false,
          fasteners: 'g2',
        },
      };
    },
    computed: {
      canTShaped() {
        return this.separate;
      },
      fastenersOptions() {
        return [
          {
            value: 'g2',
            text: 'Г-образные крепежи на верхней и нижней полках',
            hint: '',
            disabled: false,
          },
          {
            value: 'g3',
            text: 'Г-образные крепежи на верхней, нижней и средней полках',
            hint: 'Увеличивают базовую нагрузку на стеллаж на 10%',
            disabled: false,
          },
          {
            value: 'gall',
            text: 'Г-образные крепежи на всех полках',
            hint: 'Увеличивают базовую нагрузку на стеллаж на 20%',
            disabled: false,
          },
          {
            value: 't2',
            text: 'Т-образные крепежи на верхней и нижней полках',
            hint: 'Увеличивают базовую нагрузку на стеллаж на 15%',
            disabled: !this.separate,
          },
          {
            value: 't3',
            text: 'Т-образные крепежи на верхней, нижней и средней полках',
            hint: 'Увеличивают базовую нагрузку на стеллаж на 20%',
            disabled: !this.separate,
          },
          {
            value: 'tall',
            text: 'Т-образные крепежи на всех полках',
            hint: 'Увеличивают базовую нагрузку на стеллаж на 50%',
            disabled: !this.separate,
          },
        ];
      },
    },
    watch: {
      form: {
        deep: true,
        immediate: true,
        handler: 'updateWeight',
      },
      value(value) {
        this.form = Object.assign({}, this.form, value);
      },
    },
    methods: {
      close() {
        this.$emit('close');
      },
      submit() {
        this.$emit('input', this.form);
        this.$emit('close');
      },
      updateWeight() {
        const { rack_kit_weight, tier_shelf_weight } = logic.getWeight(this.separate, this.form);

        this.form.rack_kit_weight = rack_kit_weight;
        this.form.tier_shelf_weight = tier_shelf_weight;
      },
    },
  };
</script>

<style scoped>
  .form {
    font-size: 14px;
  }
  .form button {
    width: auto;
  }
  .capacity {
    display: flex;
    margin-bottom: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #DDDDDD;
  }
  .capacity-label {
    margin-right: 17px;
    font-weight: bold;
    text-transform: uppercase;
  }
</style>
